import { atom } from "recoil";

export const actionMenuState = atom({
  key: "actionMenuState",
  default: null,
});
